import 'css-chunksrc/client/scenes/optimizedGantt/calendar/years/year/styles.scss';export default {
  "year": "_year_kzbaa_1",
  "yearName": "_yearName_kzbaa_14",
  "months": "_months_kzbaa_29",
  "month": "_month_kzbaa_29",
  "monthNbr": "_monthNbr_kzbaa_51",
  "even": "_even_kzbaa_55",
  "odd": "_odd_kzbaa_59"
};